export default __webpack_public_path__ + "static/media/CreateAnAccount.1f362a16.png";